import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MENU = _resolveComponent("MENU")
  const _component_el_menu = _resolveComponent("el-menu")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_menu, {
      collapse: _ctx.state.isSidebarNavCollapse,
      "text-color": "#eee",
      "active-text-color": "#4dbcff",
      "default-active": _ctx.state.currentMenu,
      class: "theme-bg",
      id: "menu",
      "unique-opened": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_MENU, {
          menuList: _ctx.state.sidebarMenu
        }, null, 8, ["menuList"])
      ]),
      _: 1
    }, 8, ["collapse", "default-active"])
  ]))
}